/*
  Shop chat button position on phones (adam, 9 Oct 2026).
  - 30px tall like the pill; sits 12px from the bottom and 10px from the right (raised + moved in 9 Oct for iPhone rounded corners), on the same line as the "GET $20 OFF*" Klaviyo pill.
  - When the sticky ADD TO BAG bar is showing (product pages), our rule switches off and Shopify's own position
    applies, which already sits above the bar on phones (adam, 9 Oct).
  - Desktop: while that bar shows, the button is lifted to 12px above it (measured live); otherwise Shopify's spot.
  Shopify Inbox draws the button inside nested open shadow roots (shopify-chat > shopify-agent-runtime),
  so theme CSS can't reach it: we add a small <style> inside the runtime's shadow root and toggle a class on it.
*/
(function () {
  var CSS =
    '@media screen and (max-width: 749px) {' +
    '.activator-nudge { transition: bottom .25s ease, right .25s ease !important; }' +
    ':host(:not(.lp-chat-lift)) .activator-nudge { bottom: 12px !important; right: 10px !important; }' +
    // Same height as the GET $20 OFF* pill (30px), with an invisible 8px tap margin (adam, 9 Oct).
    '.activator { width: 30px !important; height: 30px !important; min-width: 0 !important; min-height: 0 !important; padding: 0 !important; border-radius: 15px !important; position: relative !important; background: rgba(76, 76, 76, .9) !important; opacity: 1 !important; }' +
    '.activator::after { content: "" !important; position: absolute !important; inset: -8px !important; }' +
    '.activator__icon { width: 15px !important; height: 15px !important; }' +
    '.activator__icon > * { width: 15px !important; height: 15px !important; }' +
    '}' +
    // Desktop: the full-width sticky ADD TO BAG bar is taller than Shopify allows for, so lift the button
    // 12px above the bar while it shows (adam, 9 Oct). --lp-chat-lift is measured from the bar in sync().
    '@media screen and (min-width: 750px) {' +
    '.activator-nudge { transition: bottom .25s ease !important; }' +
    ':host(.lp-chat-lift) .activator-nudge { bottom: var(--lp-chat-lift, 130px) !important; }' +
    '}';

  // Find the shadow root that holds the chat button, however deeply Shopify nests it (it differs in the theme editor).
  function findRoot(root, depth) {
    if (!root || depth > 6) return null;
    if (root.querySelector && root.querySelector('.activator-nudge')) return root;
    var all = root.querySelectorAll ? root.querySelectorAll('*') : [];
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) { var r = findRoot(all[i].shadowRoot, depth + 1); if (r) return r; }
    }
    return null;
  }

  function inject() {
    var chat = document.querySelector('shopify-chat');
    var root = chat && chat.shadowRoot ? findRoot(chat.shadowRoot, 0) : null;
    if (!root) return null;
    if (!root.getElementById('lp-chat-position')) {
      var style = document.createElement('style');
      style.id = 'lp-chat-position';
      style.textContent = CSS;
      root.appendChild(style);
    }
    return root.host;
  }

  function sync() {
    var host = inject();
    if (!host) return;
    var bar = document.querySelector('.sticky-atc-wrapper--visible');
    host.classList.toggle('lp-chat-lift', !!bar);
    var box = bar && (bar.querySelector('.sticky-atc-box') || bar);
    if (box) {
      var top = box.getBoundingClientRect().top;
      if (top > 0 && top < window.innerHeight) host.style.setProperty('--lp-chat-lift', Math.round(window.innerHeight - top + 12) + 'px');
    }
  }

  // The chat loads after the page and can be redrawn later (e.g. in the theme editor): re-check every second.
  setInterval(sync, 1000);
  sync();

  // Follow the sticky ADD TO BAG bar as it shows and hides.
  var queued = false;
  function onChange() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; sync(); });
  }
  window.addEventListener('scroll', onChange, { passive: true });
  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.querySelector('.sticky-atc-wrapper');
    if (bar) new MutationObserver(onChange).observe(bar, { attributes: true, attributeFilter: ['class'] });
  });
})();
